import localDataApi from '@/api/localDataApi'
import db from '@/repos/indexDB'
import { exportDB, importDB } from "dexie-export-import";
import store from "@/store";
import moment from "moment";

export default {
	async uploadLocalData() {
		let localDB = await exportDB(db)

		return await localDataApi.uploadLocalData(localDB);
	},
	async saveLocalData() {
		let localDB = await exportDB(db);

		let userName = store.getters["UserStore/getFullName"];
		let personnelId = store.getters["UserStore/getPersonnelID"];
		let fileName = `${userName}(${personnelId})/${moment().format("YYYY-MM-DD/HH:mm:ss")}.json`;

		let url = window.URL.createObjectURL(localDB);
		let link = document.createElement("a");
		link.href = url;
		link.setAttribute('download', fileName);
		document.body.appendChild(link);
		link.click();
		link.remove();
		window.URL.revokeObjectURL(url);
	},
	async importLocalData() {
		let file = await selectFile();
		if (file == null) {
			throw new Error("No file selected")
		}

		db.delete();
		await importDB(file);
		window.location.reload();
	},
	async clearLocalData() {
		await db.delete();
		window.location.href="/";
	}
}

async function selectFile() {
	return new Promise((resolve, reject) => {
		try {
			let input = document.createElement("input");
			input.setAttribute('type', 'file');
			input.onchange = (event) => {
				try {
					const files = event.target.files;
					if (files[0] !== undefined) {
						resolve(files[0]);
						return
					}

					resolve(null)
				} catch (err) {
					reject(err);
				}
			}
			document.body.appendChild(input);
			input.click();
			input.remove();
		} catch (err) {
			reject(err);
		}
	});
}